// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as FilterFunctor from "../../../../../../library/filter-module/filter-view-template/FilterFunctor.bs.js";
import * as FilterTicketConfig from "./FilterTicketConfig.bs.js";

var TicketsFilterComponent = FilterFunctor.T(FilterTicketConfig.T);

function FilterTicketComponent(Props) {
  var params = Props.params;
  return React.createElement(TicketsFilterComponent.make, {
              params: params
            });
}

var make = FilterTicketComponent;

export {
  TicketsFilterComponent ,
  make ,
  
}
/* TicketsFilterComponent Not a pure module */
